<template lang="pug">
	div
		h1 {{contentpage.name}}
		ws-content(:value="contentpage.content")
			template(slot="measurepoints")
				div(v-for="snowheight in area.snowheights.nodes" :key="snowheight.location")
					h2 {{$t('page.areas._area.snowheight:measurepoint_{location}', {location: snowheight.location})}}
					snowheights-stats-card(:snowheight="snowheight")
					v-divider.my-6
			template(slot="snowheight_nearby")
				snowheights-nearby-table(:coordinates="area.geography.location.coordinates" :selected-area-id="area.id")
				v-divider.my-6
			template(slot="snowheight_history")
				barchart(:data="historyGraphdata")
				v-divider.mt-0.mb-6
			template(slot="checklist")
				ws-checklist(:area-id="area.id")
</template>

<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import Barchart from '@/components/display/barchart.vue';
import SnowheightsStatsCard from '@/components/snowheights/stats-card.vue';
import SnowheightsNearbyTable from '@/components/snowheights/nearby-table.vue';
import snowheightHistoryMixin from '@/mixins/snowheight-history.js';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const getAreaSnowheight = gql`
	query getAreaSnowheight($slug: String!, $path: String, $fallback: String) {
		contentpage(path: $path, fallback: $fallback) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
		area(slug: $slug) {
			id
			name
			slug
			country {
				id
				name
				countryCode
				slug
			}
			region {
				id
				name
				slug
			}
			geography {
				location {
					coordinates
				}
			}
			forecasthistory {
				rundate
				snowTotal
			}
			snowheights {
				maxSnowMountain
				maxSnowValley
				nodes {
					...SnowheightStatCardData
				}
			}
		}
	}
	${MetaFragment}
	${Content.fragments}
	${SnowheightsStatsCard.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/skigebieden/:area/sneeuwhoogte',
			'de-DE': '/skigebiete/:area/schneehoehe',
			'nl-BE': '/skigebieden/:area/sneeuwhoogte'
		}
	},
	components: { Barchart, SnowheightsStatsCard, SnowheightsNearbyTable },
	mixins: [snowheightHistoryMixin],
	layout: 'default',
	// eslint-disable-next-line @milqmedia/milq/page-has-meta
	asyncData({ params, app, route }) {
		return app.$graphClient
			.query({
				query: getAreaSnowheight,
				variables: {
					slug: params.area,
					path: route.path,
					fallback: route.path.replace(params.area, '_area')
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(404, null, 'area-snowheight-01', errors);
				}
				if (errors) {
					throw errors[0];
				}

				app.interpolater(data.contentpage.meta, ['title', 'description']);
				app.interpolater(data.contentpage.content, ['markdown']);
				app.interpolater(data.contentpage, ['name']);

				app.meta(data.contentpage.meta);
				app.ads({
					sidebar: {
						visible: true,
						targets: {
							Skiresort: data.area.id,
							State: data.area.region.id,
							Country: data.area.country.id
						}
					}
				});
				app.areaBreadcrumbs(data.area, {
					[app.i18n.t(`page.areas._area.snowheight:breadcrumb`)]: {
						name: 'areas-area-snowheight',
						params: { area: data.area.slug }
					}
				});

				return data;
			})
			.catch(app.$destinationNotFoundCatcher)
			.catch(error => {
				return app.httpError(500, null, 'areas-area-snowheight-02', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	created() {
		this.$emit('update:showSidebar', true);
	}
};
</script>
